import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
export var CommentDetail = styled.div.withConfig({
  displayName: "CommentDetail",
  componentId: "sc-1vrdzpx-0"
})(["margin-bottom:12px;", ";line-height:2;&:last-child{margin-bottom:6px;}", ";> *:nth-child(2){position:relative;flex:1;padding-left:18px;", ";&:before{position:absolute;top:0;bottom:0;left:0;width:3px;border-radius:1.5px;content:'';background-color:", ";}}"], getFont(-1, 'compact'), minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: flex-start;\n  "]))), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-left: 3px;\n      padding-left: 15px;\n    "]))), function (_ref) {
  var theme = _ref.theme,
    isAuthor = _ref.isAuthor;
  return isAuthor ? theme.secondaryColor : theme.borderColor;
});
export var CommentAuthor = styled.div.withConfig({
  displayName: "CommentDetail__CommentAuthor",
  componentId: "sc-1vrdzpx-1"
})(["width:114px;min-width:114px;a{color:currentColor;&:hover{color:", ";}}", ";", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mainColor;
}, maxMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-bottom: 6px;\n  "]))), minMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    padding-right: 18px;\n    text-align: right;\n\n    div {\n      text-align: left;\n    }\n  "]))));
export var CommentText = styled.div.withConfig({
  displayName: "CommentDetail__CommentText",
  componentId: "sc-1vrdzpx-2"
})(["min-width:1%;word-break:break-word;"]);